<div class="search-box" id="search-box">
    <div class="search-box__info">
        <div>
            <img class="search-box__logo" [src]="'styles/assets/logo/SAL_logo.png'" [alt]="'SAL logo'" />
            <h1>{{ appName() }}</h1>
        </div>
        <div class="invisible-onscroll">{{ 'search.description' | translate }}</div>
        <div>
            <div class="search-box__input">
                <input
                    class="form-control"
                    [(ngModel)]="searchString"
                    [disabled]="isAdvancedSearch()"
                    [attr.aria-label]="'search.placeholder' | translate"
                    [placeholder]="'search.placeholder' | translate"
                    (keyup.enter)="search(false, $event)"
                />
                <button
                    type="button"
                    class="btn btn-ghost btn-icon search-button"
                    [disabled]="isAdvancedSearch()"
                    [attr.aria-label]="'accessibility.search' | translate"
                    (click)="search(false, $event)"
                >
                    <i aria-hidden="true" class="icon element-search"></i>
                </button>
            </div>
            <button
                type="button"
                class="btn btn-ghost btn-icon search-filter-button m-6"
                [attr.aria-label]="'accessibility.toggle-advanced-search' | translate"
                (click)="toggleAdvancedSearch()"
            >
                <i
                    aria-hidden="true"
                    class="icon"
                    [class.element-filter-filled]="isAdvancedSearch()"
                    [class.element-filter]="!isAdvancedSearch()"
                ></i>
            </button>
        </div>
    </div>
    @if (isAdvancedSearch()) {
        <form [formGroup]="searchForm" class="search-box__advanced-search">
            <div class="advanced-search__inputs">
                <si-form-item [label]="'search.refine.firm' | translate">
                    <input
                        class="form-control"
                        formControlName="firm"
                        [attr.aria-label]="'search.refine.firm' | translate"
                        (keyup.enter)="search(true, $event)"
                    />
                </si-form-item>
                <si-form-item [label]="'search.refine.locCode' | translate">
                    <input
                        class="form-control"
                        formControlName="loccode"
                        [attr.aria-label]="'search.refine.locCode' | translate"
                        (keyup.enter)="search(true, $event)"
                    />
                </si-form-item>
                <si-form-item [label]="'search.refine.country' | translate">
                    <input
                        class="form-control"
                        type="text"
                        formControlName="country"
                        [attr.aria-label]="'search.refine.country' | translate"
                        (keyup.enter)="search(true, $event)"
                    />
                </si-form-item>
                <si-form-item [label]="'search.refine.city' | translate">
                    <input
                        class="form-control"
                        formControlName="city"
                        [attr.aria-label]="'search.refine.city' | translate"
                        (keyup.enter)="search(true, $event)"
                    />
                </si-form-item>
                <si-form-item [label]="'search.refine.address' | translate">
                    <input
                        class="form-control"
                        formControlName="address"
                        [attr.aria-label]="'search.refine.address' | translate"
                        (keyup.enter)="search(true, $event)"
                    />
                </si-form-item>
                <si-form-item [label]="'search.refine.postalcode' | translate">
                    <input
                        class="form-control"
                        formControlName="postalcode"
                        [attr.aria-label]="'search.refine.postalcode' | translate"
                        (keyup.enter)="search(true, $event)"
                    />
                </si-form-item>
                <si-form-item [label]="'search.refine.section' | translate">
                    <input
                        class="form-control"
                        formControlName="section"
                        [attr.aria-label]="'search.refine.section' | translate"
                        (keyup.enter)="search(true, $event)"
                    />
                </si-form-item>
                <si-form-item [label]="'search.refine.are' | translate">
                    <input
                        class="form-control"
                        formControlName="are"
                        [attr.aria-label]="'search.refine.are' | translate"
                        (keyup.enter)="search(true, $event)"
                    />
                </si-form-item>
                <si-form-item [label]="'search.refine.corporatetype' | translate">
                    <input
                        class="form-control"
                        formControlName="corporatetype"
                        [attr.aria-label]="'search.refine.corporatetype' | translate"
                        (keyup.enter)="search(true, $event)"
                    />
                </si-form-item>
                <si-form-item [label]="'search.refine.businessactivity' | translate">
                    <input
                        class="form-control"
                        formControlName="businessactivity"
                        [attr.aria-label]="'search.refine.businessactivity' | translate"
                        (keyup.enter)="search(true, $event)"
                    />
                </si-form-item>
            </div>
            <div class="advanced-search__actions">
                <si-form-item [label]="'Headquarter-Locations' | translate">
                    <input
                        type="checkbox"
                        class="form-check-input"
                        formControlName="headquarter"
                        [attr.aria-label]="'Headquarter-Locations' | translate"
                    />
                </si-form-item>
                <div class="action-btns">
                    <button
                        type="button"
                        class="btn btn-primary"
                        [attr.aria-label]="'accessibility.reset-search-filters' | translate"
                        (click)="resetFilters()"
                    >
                        <i aria-hidden="true" class="icon element-refresh"></i>
                        <span>{{ '_resetFilter' | translate }}</span>
                    </button>
                    <button
                        type="button"
                        class="btn btn-primary"
                        [attr.aria-label]="'accessibility.submit-advanced-search' | translate"
                        (click)="search(true, $event)"
                    >
                        <i aria-hidden="true" class="icon element-search"></i>
                        <span>{{ '_search' | translate }}</span>
                    </button>
                </div>
            </div>
        </form>
    }
</div>
